import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CrearLandingComponent, DialogGaleriaImagenes } from './crear-landing.component';
import { CrearLandingRoutingModule } from './crear-landing-routing.module';
import { MaterialModule } from '../../material/material.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PipesModule } from '../../../pipes/pipes.module';
import { ImageUploadModule } from '../../archivos/image-upload.module';
import { LandingService } from '../../../providers/landing.service';
import { GeneralService } from '../../../providers/general.service';
import { ColorPickerModule } from 'ngx-color-picker';
import { CKEditorModule } from 'ckeditor4-angular';
import { UICarouselModule } from "ui-carousel";
import { SlideshowModule } from 'ng-simple-slideshow';
@NgModule({
  declarations: [CrearLandingComponent, DialogGaleriaImagenes],
  imports: [
    CommonModule,
    CrearLandingRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    PipesModule,
    ImageUploadModule.forRoot(),
    ColorPickerModule,
    CKEditorModule,
    UICarouselModule,
    SlideshowModule
  ],
  exports: [CrearLandingComponent],
  entryComponents: [CrearLandingComponent, DialogGaleriaImagenes],
  providers: [
    LandingService,
  ]
})
export class CrearLandingModule { }
